<div class="container">
  <div class="row">
    <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
      <div class="flash-message-container">
        <flash-message></flash-message>
      </div>
      <div class="panel panel-default-agro1">
        <div class="panel-heading"></div>

        <div class="panel-body">
          <div class="text-center logo">
            <img src="images/aqila.png" class="img-resonsive">
          </div>

          <form novalidate name="loginForm" ng-submit="doLogin(login)">
            <div class="form-group" agro-show-errors>
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-user" aria-hidden="true"></i>
                </div>
                <input type="text" class="form-control" name="nome" ng-model="login.nome" required autofocus placeholder="Usuário">
              </div>
            </div>

            <div class="form-group" agro-show-errors>
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                </div>
                <input type="password" class="form-control" name="Senha" ng-model="login.senha" required placeholder="Senha">
              </div>
            </div>

            <div class="form-group">
              <div class="alert alert-danger" ng-bind="error" ng-show="error"></div>
            </div>

            <button type="submit" class="btn btn-agro1 btn-block" ng-disabled="loginForm.$invalid || loading">
              Entrar
              <span ng-show="loading">
                <i class="fa fa-spinner fa-spin"></i>
              </span>
            </button>
          </form>
        </div>

        <div class="panel-footer text-center">
          <small>© Copyright - Agro1</small>
        </div>
      </div>
    </div>
  </div>
</div>
